/* eslint-disable */
import React, { useState, useEffect, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./UploadVideo.module.css";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Modal from "@material-ui/core/Modal";
import SelectTag from "./SelectTag";
import {
  Chip,
  CircularProgress,
  createStyles,
  makeStyles,
} from "@material-ui/core";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import { GetUserInfoList } from "../../user/UserActions";
import { AppState } from "../../root/RootReducer";
import { AddVideo } from "../../common/video/VideoActions";
import UploadDocument from "../../pages/vod/Common/UploadDocument";
import { countCharLength } from "../../utils/ValidationUtils";
import PuiMessage from "../../components/widgets/PuiMessage";
import PuiFloatButton from "../../components/elements/PuiFloatButton";
import useResponsive from "../../common/useResponsive";
import { LANGUAGE_OPTIONS } from "../../utils/Contants"
import { isAdmin, isPresenter } from "src/utils/LogicUtils";
import { useQuery } from "@tanstack/react-query";
import { UserList } from "src/user/User";

interface UploadVideoProps {
  setIsSaved: (isSaved: boolean) => void;
  isSaved: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    input: {
      width: "100%",
      "& .MuiInputLabel-root.Mui-focused": {
        borderColor: "var(--red)",
      },
    },
    select: {
      "& .MuiInputLabel-root.Mui-focused": {
        borderColor: "var(--red)",
      },
    },
    inputMobile: {
      width: "100%",
      "& .MuiOutlinedInput-root": {
        padding: 0,
        "& input": {
          height: 36,
          fontSize: 12,
          padding: "0 6px",
          boxSizing: "border-box",
        },
        "& textarea": {
          fontSize: 12,
          padding: "6px",
        },
      },
      "& .MuiInputLabel-root.Mui-focused": {
        borderColor: "var(--red)",
      },
    },
    selectMobile: {
      "& .MuiOutlinedInput-input": {
        width: 255,
        height: 36,
        fontSize: 12,
        padding: "0 6px",
        display: "flex",
        alignItems: "center",
      },
      "& .MuiInputLabel-root.Mui-focused": {
        borderColor: "var(--red)",
      },
    },
    selectlanguage: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Noto Sans SC", "Noto Sans JP", sans-serif',
      "& .MuiOutlinedInput-input": {
        width: 120,
      },
      "& .MuiInputLabel-root.Mui-focused": {
        borderColor: "var(--red)",
      },
    },
    menuPaperMobile: {
      "& .MuiMenuItem-root": {
        minHeight: 36,
        fontSize: 12,
      }
    },
  })
);

export default function UploadVideo({ setIsSaved, isSaved }: UploadVideoProps) {
  const classes = useStyles();
  const { isMobile } = useResponsive();

  // ユーザー取得
  const { isSendVideo, isLoading,userInfo } = useSelector(
    (state: AppState) => ({
      isSendVideo: state.video.isSendVideo,
      isLoading: false,
      userInfo: state.user.userInfo,
    })
  );



  const dispatch = useDispatch();
  const inputVideoRef = useRef<HTMLInputElement>(null);
  const inputImageRef = useRef<HTMLInputElement>(null);

  // タグ選択モーダル画面
  const [tagList, setTagList] = React.useState<string[]>([]);
  const { data:professionals } = useQuery<UserList[]>({
    queryKey:['/api/getUserInfoList']
  })

  const isOnlyPresenter = useMemo(() => {
    return !isAdmin(userInfo?.roles) && isPresenter(userInfo?.roles);
  },[userInfo])

  const [inputVideoFile, InputVideoFile] = useState(null);
  const [inputVideoFileName, InputVideoFileName] = useState("");
  const [inputVideoName, InputVideoName] = useState("");
  const [visiblePreviewImage, ChangevisiblePreviewImage] = useState(false);
  const [inputImageFile, InputImageFile] = useState(null);

  function getInitialProfessional() {
    return isOnlyPresenter ? userInfo?.id || "" : "";
  }

  const [inputVideoProfessional, InputVideoProfessional] = useState(getInitialProfessional);
  const [inputVideoLanguage, InputVideoLanguage] = useState("zh");
  const [inputVideoDetail, InputVideoDetail] = useState("");

  const [isErrorInputSize, ChangeErrorInputSize] = useState(false);
  // ファイルサイズエラーバー消去
  const CloseErrorInputBar = () => {
    ChangeErrorInputSize(false);
  };

  const UserInputVideoFile = (event: any) => {
    console.log("UserInputVideoFile");
    InputVideoFile(event.target.files[0]);
    InputVideoFileName(event.target.files[0].name);
    setIsSaved(false);
  };
  const UserInputVideoName = (event: any) => {
    InputVideoName(event.target.value);
    setIsSaved(false);
  };
  const UserInputImageFile = (event: any) => {
    InputImageFile(event.target.files[0]);
    setIsSaved(false);
  };
  const UserInputVideoProfessional = (event: any) => {
    InputVideoProfessional(event.target.value);
    setIsSaved(false);
  };

  const UserInputVideoLanguage = (event: any) => {
    InputVideoLanguage(event.target.value);
    setIsSaved(false);
  };

  const UserInputVideoDescription = (event: any) => {
    InputVideoDetail(event.target.value);
    setIsSaved(false);
  };

  // ビデオタイトルチェック
  const [isErrorTitleValidation, CheckTitleValidation] = useState(false);
  const ChangeTitle = (event: any) => {
    if (countCharLength(event.target.value) > 40) {
      UserInputVideoName(event);
      CheckTitleValidation(true);
    } else {
      CheckTitleValidation(false);
      UserInputVideoName(event);
    }
    setIsSaved(false);
  };

  //ビデオ要約チェック
  const [isErrorDescriptionValidation, CheckDescriptionValidation] =
    useState(false);
  const ChangeDescription = (event: any) => {
    if (countCharLength(event.target.value) > 400) {
      UserInputVideoDescription(event);
      CheckDescriptionValidation(true);
    } else {
      CheckDescriptionValidation(false);
      UserInputVideoDescription(event);
    }
    setIsSaved(false);
  };

  // 資料アップロード
  const [inputDocumentList, ChangeDocumentList] = useState<File[]>([]);
  const [inputDocumentNameList, ChangeDocumentNameList] = useState<string[]>(
    []
  );
  const [isErrorDocumentListLength, ErrorDocumentListLength] = useState(false);

  // ビデオファイルアップロードテキスト
  const [textUploadVideo, ChangeTextUploadVideo] = useState(
    "アップロードするファイルを選択（4GBまで）"
  );
  const [isLimitInputFileSize, ChangeLimitInputFileSize] = useState(false);
  const UserUploadVideo = (event: any) => {
    console.log("UserUploadVideo");
    if (event.target.files.length === 0) {
      ChangeTextUploadVideo("アップロードするファイルを選択（4GBまで）");
      InputVideoFile(null);
      InputVideoFileName("");
      if (inputVideoRef.current) {
        inputVideoRef.current.value = "";
      }
    } else if (event.target.files.length === 1) {
      if (event.target.files[0].size > 0) {
        if (event.target.files[0].size > 4294967296) {
          ChangeLimitInputFileSize(true);
          if (inputVideoRef.current) {
            inputVideoRef.current.value = "";
          }
        } else {
          UserInputVideoFile(event);
          ChangeTextUploadVideo(event.target.files[0].name);
        }
      } else {
        ChangeErrorInputSize(true);
        if (inputVideoRef.current) {
          inputVideoRef.current.value = "";
        }
      }
    } else {
      ChangeTextUploadVideo("ファイルを正しく選択してください（4GBまで）");
      InputVideoFile(null);
      InputVideoFileName("");
      if (inputVideoRef.current) {
        inputVideoRef.current.value = "";
      }
    }
    setIsSaved(false);
  };

  // ファイルサイズ制限バー消去
  const CloseLimitInputFileBar = () => {
    ChangeLimitInputFileSize(false);
  };

  // 画像ファイルアップロードテキスト
  const [textUploadImage, ChangeTextUploadImage] = useState(
    "Videoサムネイル用のファイルを選択"
  );
  const [isLimitInputImageSize, ChangeLimitInputImageSize] = useState(false);
  const UserUploadImage = (event: any) => {
    console.log("UserUploadImage start");
    if (event.target.files.length === 0) {
      ChangevisiblePreviewImage(false);
      ChangeTextUploadImage("Videoサムネイル用のファイルを選択");
      InputImageFile(null);
      if (inputImageRef.current) {
        inputImageRef.current.value = "";
      }
    } else if (event.target.files.length === 1) {
      if (event.target.files[0].size > 0) {
        if (event.target.files[0].size > 10485760) {
          ChangeLimitInputImageSize(true);
          if (inputImageRef.current) {
            inputImageRef.current.value = "";
          }
        } else {
          UserInputImageFile(event);
          ChangeTextUploadImage(event.target.files[0].name);
          InputImageFile(event.target.files[0]);
          ChangevisiblePreviewImage(true);
        }
      } else {
        ChangeErrorInputSize(true);
        if (inputImageRef.current) {
          inputImageRef.current.value = "";
        }
      }
    } else {
      ChangevisiblePreviewImage(false);
      ChangeTextUploadImage("ファイルを正しく選択してください");
      InputImageFile(null);
      if (inputImageRef.current) {
        inputImageRef.current.value = "";
      }
    }
    setIsSaved(false);
  };

  // サムネイルサイズ制限バー消去
  const CloseLimitInputImageBar = () => {
    ChangeLimitInputImageSize(false);
  };

  // ユーザのプレビュー画像クリックで、テキスト表示に戻す
  const ClickPreviewImage = (event: any) => {
    console.log("ClickPreviewImage start");
    ChangeTextUploadImage("Videoサムネイル用のファイルを選択（4GBまで）");
    InputImageFile(null);
    ChangevisiblePreviewImage(false);
    setIsSaved(false);
  };

  // タグ選択モーダル画面表示制御
  const [isOpenTagSelectModal, ShowTagSelectModal] = useState(false);
  const OpenTagSelectModal = () => {
    ShowTagSelectModal(true);
  };
  const CloseTagSelectModal = () => {
    ShowTagSelectModal(false);
  };

  const handleDelete = (tagName: string) => () => {
    setTagList((tagList) => tagList.filter((v) => v !== tagName));
    setIsSaved(false);
  };

  // 入力内容をバックエンドに送信
  const UploadVideo = () => {
    if (
      inputVideoName !== "" &&
      inputVideoDetail !== "" &&
      inputVideoProfessional !== "-1" &&
      inputVideoProfessional !== "" &&
      inputVideoFile !== null &&
      isErrorTitleValidation === false &&
      isErrorDescriptionValidation === false
    ) {
      dispatch(
        AddVideo({
          file: inputVideoFile,
          imageFile: inputImageFile,
          documentFile: inputDocumentList,
          documentName: inputDocumentNameList,
          video: {
            title: inputVideoName,
            description: inputVideoDetail,
            presenter: inputVideoProfessional,
            language: inputVideoLanguage,
            filename: inputVideoFileName,
            tags: tagList,
          },
        })
      );

      console.log("送信内容→");
      console.log("ビデオファイル");
      console.log(inputVideoFile);
      console.log("画像ファイル");
      console.log(inputImageFile);
      console.log("タイトル：");
      console.log(inputVideoName);
      console.log("要約：");
      console.log(inputVideoDetail);
      console.log("資料：");
      console.log(inputDocumentList);
      console.log("資料名：");
      console.log(inputDocumentNameList);
      console.log("プロフェッショナル：");
      console.log(inputVideoProfessional);
      console.log("ビデオの言語：");
      console.log(inputVideoLanguage);
      console.log("ファイル名：");
      console.log(inputVideoFileName);
      console.log("タグリスト：");
      console.log(tagList);

      // 入力内容リセット
      ResetUserInput();
    }
  };

  // 登録ボタンの有無効制御
  const [isReadyToUpdate, ChangeReadyToSendFlag] = useState(false);
  useEffect(() => {
    if (
      !isSaved &&
      inputVideoName !== "" &&
      inputVideoDetail !== "" &&
      inputVideoProfessional !== "-1" &&
      inputVideoProfessional !== "" &&
      inputVideoFile !== null &&
      !isErrorTitleValidation &&
      !isErrorDescriptionValidation &&
      !isErrorDocumentListLength
    ) {
      ChangeReadyToSendFlag(false);
    } else {
      ChangeReadyToSendFlag(true);
    }
  }, [
    isSaved,
    inputVideoName,
    inputVideoDetail,
    inputVideoProfessional,
    inputVideoLanguage,
    inputVideoFile,
    isErrorTitleValidation,
    isErrorDescriptionValidation,
    isErrorDocumentListLength,
  ]);

  // 入力内容リセット
  const ResetUserInput = () => {
    ChangeTextUploadVideo("アップロードするファイルを選択（4GBまで）");
    InputVideoFile(null);
    InputVideoFileName("");
    if (inputVideoRef.current) {
      inputVideoRef.current.value = "";
    }
    InputVideoName("");
    ChangevisiblePreviewImage(false);
    InputImageFile(null);
    ChangeTextUploadImage("Videoサムネイル用のファイルを選択");
    if (inputImageRef.current) {
      inputImageRef.current.value = "";
    }
    InputVideoProfessional(getInitialProfessional());
    InputVideoLanguage("zh")
    InputVideoDetail("");
    ChangeDocumentList([]);
    ChangeDocumentNameList([]);
    setTagList([]);
    setIsSaved(true);
  };

  // 表示待機
  if (isLoading) {
    return (
      <div className={styles.noContent}>
        <CircularProgress size={60} style={{ color: "var(--red)" }} />
      </div>
    );
  }

  console.log(professionals);

  return (
    <div className={styles.root}>
      <ul className={styles.inputForm}>
        <FormControl>
          <form name="addVideoForm" id="addVideoForm">
            {/* ビデオファイル */}
            <li className={styles.mobileFormItem}>
              <div className={styles.formHelperText}>
                Videoファイル<sup style={{ color: "var(--red)" }}>*</sup>
              </div>
              <div className={styles.form}>
                <label className={styles.uploadButton}>
                  <input
                    id="browserVideoUploader"
                    ref={inputVideoRef}
                    multiple
                    type="file"
                    accept="video/*"
                    onChange={UserUploadVideo}
                    className={styles.fileDisplay}
                  />
                  {textUploadVideo}
                </label>
              </div>
            </li>
            <li className={styles.mobileFormItem}>
              <div className={styles.formHelperText}>
                Video言語<sup style={{ color: "var(--red)" }}>*</sup>
              </div>
              <div className={styles.form}>
                <Select
                  color="secondary"
                  id="selectVideoLanguage"
                  variant="outlined"
                  defaultValue="zh"
                  onChange={UserInputVideoLanguage}
                  value={inputVideoLanguage}
                  className={isMobile ? classes.selectMobile : classes.selectlanguage}
                  MenuProps={isMobile && { classes: { paper: classes.menuPaperMobile } }}
                >
                  {LANGUAGE_OPTIONS !== undefined &&
                    LANGUAGE_OPTIONS.map(
                      (row) =>
                        <MenuItem key={row.value} value={row.value}>
                          {row.label}
                        </MenuItem>
                    )}
                </Select>
              </div>
            </li>
            {/* 画像サムネイルファイル */}
            <li className={styles.mobileFormItem}>
              <div className={styles.formHelperText}>サムネイル</div>
              {visiblePreviewImage ? (
                inputImageFile !== null && (
                  <div style={{ display: "flex" }}>
                    <div className={styles.previewImage}>
                      <img
                        style={{ cursor: "pointer" }}
                        alt="thumbnail"
                        src={window.URL.createObjectURL(inputImageFile)}
                        onClick={ClickPreviewImage}
                      />
                    </div>
                    <p className={styles.previewText}>
                      サムネイル画像を指定しない場合は、Videoから自動的にサムネイルが抽出されます
                    </p>
                  </div>
                )
              ) : (
                <div className={styles.form}>
                  <label className={styles.uploadButton}>
                    <input
                      id="browserPhotoUploader"
                      ref={inputImageRef}
                      multiple
                      type="file"
                      accept="image/*"
                      onChange={UserUploadImage}
                      className={styles.fileDisplay}
                    />
                    {textUploadImage}
                  </label>
                </div>
              )}
            </li>

            {/* タイトル */}
            <li className={styles.mobileFormItem}>
              <div className={styles.formHelperText}>
                タイトル<sup style={{ color: "var(--red)" }}>*</sup>
              </div>
              <div className={styles.form}>
                <TextField
                  color="secondary"
                  className={isMobile ? classes.inputMobile : classes.input}
                  id="VideoName"
                  variant="outlined"
                  placeholder="Videoタイトルを入力"
                  autoComplete="off"
                  value={inputVideoName}
                  onChange={ChangeTitle}
                  error={isErrorTitleValidation}
                  helperText={
                    isErrorTitleValidation && (
                      <span style={{ color: "var(--red)" }}>
                        全角20文字（半角40文字）以内で正しく入力してください
                      </span>
                    )
                  }
                />
              </div>
            </li>

            {/* プロフェッショナル */}
            {!isOnlyPresenter && <li className={styles.mobileFormItem}>
              <div className={styles.formHelperText}>
                Presenter<sup style={{ color: "var(--red)" }}>*</sup>
              </div>
              <div className={styles.form}>
                <Select
                  color="secondary"
                  id="selectProfessional"
                  variant="outlined"
                  defaultValue="-1"
                  onChange={UserInputVideoProfessional}
                  value={inputVideoProfessional}
                  className={isMobile ? classes.selectMobile : classes.select}
                  MenuProps={isMobile && { classes: { paper: classes.menuPaperMobile } }}
                >
                  <MenuItem value={"-1"}>Presenterを選択</MenuItem>

                  {professionals !== undefined &&
                    professionals.map(
                      (row) =>
                        row.roles.includes("PRESENTER") && (
                          <MenuItem key={row.id} value={row.id}>
                            {row.fullName}
                          </MenuItem>
                        )
                    )}
                </Select>
              </div>
            </li>}

            {/* 要約 */}
            <li className={styles.mobileFormItem}>
              <div className={styles.formHelperTextLong}>
                要約<sup style={{ color: "var(--red)" }}>*</sup>
              </div>
              <div className={styles.form}>
                <TextField
                  color="secondary"
                  id="description"
                  onChange={ChangeDescription}
                  className={isMobile ? classes.inputMobile : classes.input}
                  multiline
                  rows={5}
                  autoComplete="off"
                  value={inputVideoDetail}
                  variant="outlined"
                  placeholder="Video要約を入力"
                  error={isErrorDescriptionValidation}
                  helperText={
                    isErrorDescriptionValidation && (
                      <span style={{ color: "var(--red)" }}>
                        全角200文字（半角400文字）以内で正しく入力してください
                      </span>
                    )
                  }
                />
              </div>
            </li>

            {/* 資料 */}
            <li className={styles.mobileFormItem}>
              <div className={styles.formHelperTextLong}>資料</div>
              <UploadDocument
                alreadyUploadDocumentList={[]}
                setIsSaved={setIsSaved}
                ChangeDocumentList={ChangeDocumentList}
                documentList={inputDocumentList}
                ChangeDocumentNameList={ChangeDocumentNameList}
                documentNameList={inputDocumentNameList}
                ErrorDocumentListLength={ErrorDocumentListLength}
              />
            </li>

            {/* タグ（モーダル表示） */}
            <li className={styles.mobileFormItem}>
              <div className={styles.formHelperTextLong}>タグ</div>
              <div className={styles.formTag}>
                <AddCircleOutlineOutlinedIcon
                  style={{ cursor: "pointer", color: "var(--red)" }}
                  color="secondary"
                  fontSize="large"
                  onClick={OpenTagSelectModal}
                />
              </div>
              <div className={styles.tags}>
                {tagList &&
                  tagList.map((tag) => (
                    <Chip
                      key={tag}
                      label={tag}
                      color="secondary"
                      size="medium"
                      style={{ backgroundColor: "var(--red)" }}
                      className={styles.tag}
                      onDelete={handleDelete(tag)}
                    />
                  ))}
              </div>
            </li>
          </form>
        </FormControl>
      </ul>

      {/* ビデオ追加ボタン */}
      {isSendVideo ? (
        <div className={styles.updateButton}>
          <PuiFloatButton
            children={["　登録　"]}
            size="medium"
            isActive={false}
            onClick={UploadVideo}
          />
        </div>
      ) : (
        <div className={styles.updateButton}>
          <PuiFloatButton
            children={["　登録　"]}
            size="medium"
            isActive={!isReadyToUpdate}
            onClick={UploadVideo}
          />
        </div>
      )}

      {/* タグ選択モーダル */}
      <Modal open={isOpenTagSelectModal} onClose={CloseTagSelectModal}>
        <SelectTag
          in={isOpenTagSelectModal}
          onClose={CloseTagSelectModal}
          tagList={tagList}
          setTagList={setTagList}
          setIsSaved={setIsSaved}
        />
      </Modal>

      <PuiMessage
        open={isLimitInputFileSize}
        onClose={CloseLimitInputFileBar}
        type="error"
        title="4GB以上のファイルはアップロードできません"
        duration={5000}
      />

      {/* アップロードイメージサムネイルサイズチェック */}
      <PuiMessage
        open={isLimitInputImageSize}
        onClose={CloseLimitInputImageBar}
        type="error"
        title="10MB以上の画像はアップロードできません"
        duration={5000}
      />

      <PuiMessage
        open={isErrorInputSize}
        type="error"
        title="正しいファイルを選択してください"
        duration={5000}
        onClose={CloseErrorInputBar}
      />
    </div>
  );
}
